export const SIDE_DRAWER_CHILDREN_PAGES_KEYS = {
  salesUserDashboard: "salesUserDashboard",
  telesalesRunsheet: "telesalesRunsheet",
  trackingSalesVisits: "trackingSalesVisits",
  salesTracking: "salesTracking",
  salesAgents: "salesAgents",
  createSalesAgent: "createSalesAgent",
  editSalesAgent: "editSalesAgent",

  vendorSupport: "vendorSupport",
  repricingOrders: "repricingOrders",
  acceptedOrdersDashboard: "acceptedOrdersDashboard",

  opsNeedSupport: "opsNeedSupport",
  mechanicNeedSupport: "mechanicNeedSupport",
  towerHistory: "towerHistory",

  courierAssignmentAcceptOrders: "courierAssignmentAcceptOrders",
  courierAssignmentFulfilledOrders: "courierAssignmentFulfilledOrders",
  reallocationGroups: "reallocationGroups",
  availableCouriers: "availableCouriers",
  polygons: "polygons",
  polygonGroups: "polygonGroups",
  vehicles: "vehicles",
  courierAssignmentTransferOrder: "courierAssignmentTransferOrder",
  pendingCourierDeficits: "pendingCourierDeficits",
  courierTasks: "courierTasks",
  courierSupplierHub: "courierSupplierHub",
  couriersDashboard: "couriersDashboard",
  returnsDashboard: "returnsDashboard",
  failedReturnsDashboard: "failedReturnsDashboard",
  nonDeliveryDates: "nonDeliveryDates",
  expressHours: "expressHours",
  warehouseZones:"warehouseZones",

  pickers: "pickers",
  runsheetsDashboard: "runsheetsDashboard",
  pickerTab: "pickerTab",

  qualityReviewOrders: "qualityReviewOrders",
  qualityTickets: "qualityTickets",
  qualityReturnTickets: "qualityReturnTickets",
  qualityReturns: "qualityReturns",
  qualityNeedInvestigation: "qualityNeedInvestigation",
  qualityVoiceComplaints: "qualityVoiceComplaints",
  reasons: "reasons",

  inventoryDashboard: "inventoryDashboard",
  consignment: "consignment",
  consignmentCustomerReturns: "consignmentCustomerReturns",
  consignmentReturns: "consignmentReturns",
  inventorySaleOrders: "inventorySaleOrders",
  inventoryReturnOrders: "inventoryReturnOrders",
  inventoryPurchaseOrders: "inventoryPurchaseOrders",
  inventoryTransferOrders: "inventoryTransferOrders",
  skusMissingCbm: "skusMissingCbm",

  commercialInventoryDashboard: "commercialInventoryDashboard",
  repricingInventorySkus: "repricingInventorySkus",
  repricingRequests: "repricingRequests",
  subCategoriesMargin: "subCategoriesMargin",
  requestedProducts: "requestedProducts",
  requestsDetails: "requestsDetails",
  commercialMapping: "commercialMapping",
  mtorAiMapping: "mtorAiMapping",

  instaMart: "instaMart",
  instaMartUsers: "instaMartUsers",
  instaPartsPolygons: "instaPartsPolygons",
  instaPartsReturnOrders: "instaPartsReturnOrders",
  instaPartsStockReturns: "instaPartsStockReturns",
  instaMartPos: "instaMartPos",
  instaMartSos: "instaMartSos",
  mechanicsDashboard: "mechanicsDashboard",
  MECHANIC_CATEGORY: "mechanic_category",
  MECHANIC_SEGMENT: "mechanic_segment",
  MECHANIC_SIZE: "mechanic_size",
  suppliersDashboard: "suppliersDashboard",
  carsDashboard: "carsDashboard",
  skusDashboard: "skusDashboard",
  skusPendingVerify: "skusPendingVerify",
  skusReturnPendingVerify: "skusReturnPendingVerify",
  intersectionIds: "intersectionIds",
  skusTargets: "skusTargets",
  intersectionMatrix: "intersectionMatrix",
  brandFamiliesDashboard: "brandFamiliesDashboard",
  supplierPendingSkus: "supplierPendingSkus",
  wrongFitmentTickets: "wrongFitmentTickets",
  banners: "banners",

  skusEagleEye: "skusEagleEye",
  pricingHistoryDashboard: "pricingHistoryDashboard",
  supplierSkusPrices: "supplierSkusPrices",

  notificationService: "notificationService",
  scheduledNotifications: "scheduledNotifications",
  suppliersNotification: "suppliersNotification",
  mechanicsNotification: "mechanicsNotification",

  promotions: "promotions",
  bundles: "bundles",

  taxes: "taxes",
  instaPartsTaxes: "instaPartsTaxes",
  courierWallet: "courierWallet",
  mechanicWallet: "mechanicWallet",
  supplierWallet: "supplierWallet",
  financialHubWallet: "financialHubWallet",
  mechanicCompensations: "mechanicCompensations",

  assets: "assets",
  assetLogs: "assetLogs",
  employees: "employees",

  userManagementUsers: "userManagementUsers",
  userManagementRoles: "userManagementRoles",
  mechanicGrouping: "mechanicGrouping",
};

export const SIDE_DRAWER_PAGES_KEYS = {
  // parent modules
  mySales: "mySales",
  vendor: "vendor",
  tower: "tower",
  operations: "operations",
  picking: "picking",
  quality: "quality",
  inventory: "inventory",
  commercial: "commercial",
  systemData: "systemData",
  pricing: "pricing",
  notificationCenter: "notificationCenter",
  deals: "deals",
  finance: "finance",
  itManagement: "itManagement",
  userManagement: "userManagement",

  // sideDrawer single pages
  ordersDashboard: "ordersDashboard",
  parentOrders: "parentOrders",
  voiceNoteOrders: "voiceNoteOrders",
  voiceAppOrders: "voiceAppOrders",
  appStockOrders: "appStockOrders",
  appAcceptList: "appAcceptList",
  purchaseOrders: "purchaseOrders",
  chatRooms: "chatRooms",
  missingModule: "missingModule",
  stockReturns: "stockReturns",
  deepLinks: "deepLinks",
  gearbox: "gearbox",
};

export const SINGLE_PAGE_PAGES_KEYS = {
  // pages not in sideDrawer
  editOrder: "editOrder",
  orderProfile: "orderProfile",
  parentOrderProfile: "parentOrderProfile",
  pricingOrder: "pricingOrder",
  opFormOrder: "opFormOrder",
  purchaseOrderDetails: "purchaseOrderDetails",
  receiveFormDetails: "receiveFormDetails",
  requestPurchaseOrder: "requestPurchaseOrder",
  transferOrder: "transferOrder",
  newTransferOrder: "newTransferOrder",
  mechanicDetailsPage: "mechanicDetailsPage",
  newCar: "newCar",
  editCar: "editCar",
  createCarBrand: "createCarBrand",
  editCarBrand: "editCarBrand",
  createCarModel: "createCarModel",
  editCarModel: "editCarModel",
  createCarEngine: "createCarEngine",
  newSupplier: "newSupplier",
  editSupplier: "editSupplier",
  supplierPricingDashboard: "supplierPricingDashboard",
  supplierDetailsPage: "supplierDetailsPage",
  newSku: "newSku",
  editSku: "editSku",
  replicateSku: "replicateSku",
  skuDetails: "skuDetails",
  newSkuName: "newSkuName",
  newSkuBrand: "newSkuBrand",
  editSkuBrand: "editSkuBrand",
  editSkuName: "editSkuName",
  newSkuCategory: "newSkuCategory",
  editSkuCategory: "editSkuCategory",
  newSkuSubCategory: "newSkuSubCategory",
  editSkuSubCategory: "editSkuSubCategory",
  createSkuOrigin: "createSkuOrigin",
  editSkuOrigin: "editSkuOrigin",
  newSkuForSkuPending: "newSkuForSkuPending",
  newSkuForSupplierSkuPending: "newSkuForSupplierSkuPending",
  newBrandFamily: "newBrandFamily",
  editBrandFamily: "editBrandFamily",
  newPromotion: "newPromotion",
  newBundle: "newBundle",
  addRole: "addRole",
  editRole: "editRole",
  createCourier: "createCourier",
  editCourier: "editCourier",
  newStockReturnOrder: "newStockReturnOrder",
  editStockReturnOrder: "editStockReturnOrder",
  addPolygons: "addPolygons",
  newBanner: "newBanner",
  editBanner: "editBanner",
  newReason: "newReason",
  editReason: "editReason",
  createScheduledNotification: "createScheduledNotification",
  createPicker: "createPicker",
  editPicker: "editPicker",
  PickingSkuModal: "PickingSkuModal",
  pickingOrderModal: "PickingOrderModal",
  updateMtorAiMapping: "updateMtorAiMapping",
  receiveConsignmentOrder: "receiveConsignmentOrder",
  viewConsignmentOrder: "viewConsignmentOrder",
  viewConsignmentReturnOrder: "viewConsignmentReturnOrder",
};

export const PAGES_KEYS = {
  ...SIDE_DRAWER_PAGES_KEYS,
  ...SIDE_DRAWER_CHILDREN_PAGES_KEYS,
  ...SINGLE_PAGE_PAGES_KEYS,
};

export const SUPPLIER_PORTAL_PAGE_KEYS = Object.freeze({
  SUPPLIER_ORDERS: "supplier_orders",
});
